import {ResourceDrawerActivitiesSection} from '@/shared/components/ui/resource-drawer-sections'
import {useUserContext} from '@/shared/contexts'
import {Tabs} from '@chakra-ui/react'

export function ActivityTab() {
  const {activities} = useUserContext()

  return (
    <Tabs.Content value="activity">
      <ResourceDrawerActivitiesSection activities={activities} />
    </Tabs.Content>
  )
}
